import { get, put } from "aws-amplify/api";

export const ProfileService = {
  // Cache for profile data
  _profileCache: null,
  _cacheTimestamp: 0,
  _cacheTTL: 5000, // 5 seconds cache TTL
  
  async getProfile() {
    try {
      // Check if we need to bypass cache
      const now = Date.now();
      if (this._profileCache && (now - this._cacheTimestamp < this._cacheTTL)) {
        console.log('Using cached profile data');
        return this._profileCache;
      }
      
      const response = await get({
        apiName: 'userApi',
        path: '/profile'
      });
      
      console.log('Profile data received:', response);
      
      // Cache the response
      this._profileCache = response.body;
      this._cacheTimestamp = now;
      
      return response.body;
    } catch (error) {
      console.error('Error fetching profile:', error);
      throw error;
    }
  },
  
  async updateProfile(profileData) {
    try {
      console.log('Profile data to send:', profileData);
      
      const response = await put({
        apiName: 'userApi',
        path: '/profile',
        options: {
          body: profileData
        }
      });
      
      console.log('Update response:', response);
      
      // Clear cache after update to force fresh data on next get
      this._profileCache = null;
      
      return response.body;
    } catch (error) {
      console.error('Error updating profile:', error);
      throw error;
    }
  }
};